// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__GtP4H","errorLogs":"EditorFooter_errorLogs__1Rupw"};